import React from "react";
import { CssBaseline } from "@mui/material";
import {
  createTheme,
  ThemeProvider,
  Theme,
  StyledEngineProvider,
} from "@mui/material/styles";
import { customTheme } from "./customTheme";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

interface Props {
  children: React.ReactNode;
}
export function CustomMuiTheme(props: Props) {
  // const dispatch = useAppDispatch();
  // const goDarkState = useAppSelector(selectThemeType);

  // const goDarkQuery = useMediaQuery("(prefers-color-scheme: dark)");
  // useEffect(() => {
  //   dispatch(themeTypeAction(null));
  // }, [dispatch, goDarkQuery]);

  // const theme = useMemo(
  //   () =>
  //     createTheme({
  //       ...customTheme,
  //       palette: {
  //         ...customTheme.palette,
  //         mode: goDarkState ? goDarkState : goDarkQuery ? "dark" : "light",
  //       },
  //     }),
  //   [goDarkQuery, goDarkState]
  // );
  const theme = createTheme(customTheme);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
